// extracted by mini-css-extract-plugin
module.exports = {"SecondaryNavbar":"SecondaryNavbar_SecondaryNavbar__ASEhE"};